import { render, staticRenderFns } from "./_ProductSearch.vue?vue&type=template&id=e32375a2"
import script from "./_ProductSearch.vue?vue&type=script&lang=js"
export * from "./_ProductSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports